import { makeStyles } from '@mui/styles';

export default makeStyles({
    link: {
        alignItems: 'center',
        gap: 8,
        color: 'var(--lm-text)',
        display: 'inline-flex',
        textDecoration: 'none',
    },
    wordmark: {
        color: 'var(--lm-text)',
        fontFamily: '"Inter", system-ui',
        fontSize: 22,
        fontWeight: 850,
        lineHeight: '36px',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
    },
});
